// extracted by mini-css-extract-plugin
export var acceptButton = "_1c-5";
export var fullContent = "_1c-4";
export var link = "_1c-6";
export var linkIcon = "_1c-7";
export var sideContent = "_1c-3";
export var sideImage = "_1c-2";
export var sideImageWrapper = "_1c-1";
export var splitLayout = "_1c-0";